module.exports = __webpack_public_path__ + "static/media/profile_img.11d9c2fc.png";